import { logger } from '@gem/modules/logger';

import { e2eeModel } from 'APP/model/model';
import { MlsStorageService } from 'SERVICES/mlsStorageService/MlsStorageService';

import { getCommitMessages } from './getCommitMessages';

export const removeDevicesFromSecretGroup = async (
  groupId: string,
  devicesIds: string[],
  retry?: boolean
): Promise<{ error: string | null }> => {
  try {
    const mlsGroup = MlsStorageService.loadGroup(groupId);

    if (!mlsGroup) {
      throw new Error('MlsGroup does not exist');
    }

    const removeMembersResult = MlsStorageService.removeMembersByIdOrDeviceId(devicesIds, mlsGroup);

    if (!removeMembersResult) {
      return { error: null };
    }

    const response = await e2eeModel.createSecretGroupCommit({
      groupId,
      participantsWelcomeMessages: [],
      commit: removeMembersResult.commit,
      epoch: removeMembersResult.epoch,
    });

    if (response.needToSyncCommits && !retry) {
      await getCommitMessages(groupId, Number(mlsGroup.currentEpoch()));
      await removeDevicesFromSecretGroup(groupId, devicesIds, true);
    } else {
      MlsStorageService.processMyWelcomeCommit(removeMembersResult.commitOutput, mlsGroup);
    }

    return { error: null };
  } catch (error) {
    logger.get('Tasks').error('e2ee.removeMembersToSecretGroup', error);
    return { error: error.message };
  }
};
